(() => {
  document.querySelectorAll('a[target="_blank"]').forEach(link => {
    if (!link.textContent.trim() || link.querySelector('.ep-external-icon,.ep-member-arrow') || link.classList.contains('ep-whatsapp')) return;
    link.querySelectorAll('.ep-link-arrow').forEach(icon => icon.remove());
    link.querySelectorAll('span[aria-hidden="true"]').forEach(icon => { if (/^[↗→]$/.test(icon.textContent.trim())) icon.remove(); });
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('class','ep-external-icon');svg.setAttribute('aria-hidden','true');
    svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.5');
    const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M14 4h6v6M20 4 10 14M10 4H4v16h16v-6');svg.append(path);link.append(svg);
  });
  const cartLinks = [...document.querySelectorAll('[data-ep-cart-label][data-ep-cart-count-url]')];
  if (cartLinks.length) {
    let countRequest = 0;
    let countController;
    // The native event follows server markup replacement but has no count payload.
    // Read Shopify's count, since unavailable rows can cap their quantity input to zero.
    document.addEventListener('theme:cart:added', async () => {
      const request = ++countRequest;
      countController?.abort();
      countController = new AbortController();
      try {
        const response = await fetch(cartLinks[0].dataset.epCartCountUrl, {
          method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: countController.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (request !== countRequest || !Number.isSafeInteger(cart?.item_count) || cart.item_count < 0) return;
        cartLinks.forEach(link => {
          const label = link.dataset.epCartLabel;
          if (!label) return;
          const text = `${label} (${cart.item_count})`;
          link.setAttribute('aria-label', text);
          const visible = link.querySelector('[data-ep-cart-count-text]');
          if (visible) visible.textContent = text;
          const badge = link.querySelector('[data-ep-cart-count-badge]');
          if (badge) {
            badge.textContent = String(cart.item_count);
            badge.hidden = cart.item_count === 0;
          }
        });
      } catch (_) { /* Keep the last server-rendered count if this read fails. */ }
    });
  }
  const menus = [...document.querySelectorAll('[data-ep-menu], .ep-mobile-menu, [data-ep-language]')];
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
  }));
  document.addEventListener('click', event => {
    menus.forEach(menu => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = menus.find(item => item.open);
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
})();
